import { getEmailPermission } from "../../../../../actions/Utilities/EmailRecipient";
import { useQuery } from "react-query";

export default function useEmailPermission() {
  const { data } = useQuery("EmailPermission", getEmailPermission, {
    refetchOnWindowFocus: false,
  });
  return data;
}
